// src/componentes/PrivateRoute.jsx
import { Navigate } from "react-router-dom";

function PrivateRoute({ children }) {
  const isAuthenticated = !!localStorage.getItem("tempToken"); // ou outra verificação
  return isAuthenticated ? children : <Navigate to="/" replace />;
}

export default PrivateRoute;
